/**
 * Évite qu'une fonction soit appelée trop fréquemment.
 * @param {Function} func la function
 * @param {number} limit
 * @return {Function} la même fonction mais avec la limite
 */
export function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return (...args) => {
    const delta = Date.now() - (lastRan ?? 0);
    if (!lastRan) {
      func(...args);
      lastRan = Date.now();
    } else {
      if (delta > limit) {
        func(...args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(() => {
          func(...args);
          lastRan = Date.now();
        }, Math.max(0, limit - delta));
      }
    }
  };
}